import React from 'react';
import BaseModal from '../../theme/modals/BaseModal';

function SignatureModalPreSubmit({ title, onCancel, onContinue }) {
	return (
		<BaseModal visible>
			<div className="mb-4">
				{title}
			</div>

			<div className="content my-4">
				<p>
					<strong>Warning:</strong> You are submitting a project without having
					answered all required questions or uploaded all requested documents.
				</p>

				<p>
					Your project may not be presented for bid until the application is
					complete.
				</p>

				<p>
					If you need assistance, please contact CleanFi at{' '}
					<strong>877.301.7800</strong> or{' '}
					<strong>support@cleanfi.com</strong>.
				</p>

				<p>
					You may return later to finish your submission under{' '}
					<em>My Projects / My BidDesk Submissions</em>.
				</p>
			</div>

			<div className="buttons is-right">
				<button
					className="button is-danger"
					onClick={onCancel}
				>
					Return to form
				</button>

				<button
					className="button is-primary"
					onClick={onContinue}
				>
					Submit now
				</button>
			</div>
		</BaseModal>
	);
}

export default SignatureModalPreSubmit;